module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.scss
// module id = ./web/modern/components/quote/common/quote-amount-info/quote-amount-info.component.scss
// module chunks = 0